module.exports = __webpack_public_path__ + "img/logo-gray.ca3c5eb9.svg";